import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Renders a frozen V2 mockup page in a full-bleed iframe.
 * Zero visual drift — the iframe loads the exact HTML/CSS that was
 * approved and frozen at /app/frontend/public/_mockups/v2/*.html.
 *
 * `?prod=1` tells the mockup HTML to hide its dev toolbar.
 *
 * Phase 1a (2026-07-04): propagate parent-URL query parameters into the
 * iframe so embed.js can react to ?mode=preview and ?book=<slug> and
 * inject the Preview Journey overlays (chip + Next button + Sankalpa
 * pick gate). No visual redesign — the painted canvas is untouched.
 */
export default function FrozenV2Page({ slug, title }) {
  const location = useLocation();
  React.useEffect(() => { document.title = title || "iCRAFTZ"; }, [title]);

  const parentParams = new URLSearchParams(location.search);
  const iframeParams = new URLSearchParams();
  iframeParams.set("prod", "1");
  const mode = parentParams.get("mode");
  const book = parentParams.get("book");
  if (mode) iframeParams.set("mode", mode);
  if (book) iframeParams.set("book", book);

  const src = `/_mockups/v2/${slug}.html?${iframeParams.toString()}`;

  return (
    <iframe
      title={title || slug}
      data-testid={`frozen-${slug}`}
      src={src}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        border: 0,
        zIndex: 999,
        background: "#1a0e07",
      }}
    />
  );
}
